import React from 'react';
import { useDispatch } from 'react-redux';
import { setMessage } from '../../../../common/components/Notification/actions';

function ShowUploadErrorMessage({ message }) {
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (message) {
      dispatch(setMessage({ message }));
    }
  }, [message]);

  return null;
}

export default ShowUploadErrorMessage;
